import { use, useEffect } from 'react';

import { FlowContext } from '@/components/Flow';
import { WizardContext } from '@/components/Wizard';

export const useLoadingCleaner = () => {
  const { clearLoading, loading, currentFlowList } = use(WizardContext);
  const { nextStep } = use(FlowContext);

  useEffect(() => {
    if (!loading?.lastFlow || !currentFlowList) {
      return;
    }

    if (loading.lastFlow !== currentFlowList) {
      return;
    }

    const { onCompleted } = loading;

    clearLoading();

    if (onCompleted) {
      void (async () => {
        await onCompleted();
      })();

      return;
    }

    nextStep();
  }, [currentFlowList, clearLoading, loading, nextStep]);
};
